(ns frontend.ui.component.lp-portal.report.component.block-table.pdf-view
  (:require
   [clojure.string :as s]
   [common.util :as cu]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.style.theme.core :as theme]))

(defn stack-label
  [label-text]
  {:text     (s/upper-case label-text)
   :bold     true
   :fontSize 7
   :color    (theme/color [:pdf :stack :label])
   :margin   [0 0 0 0]})

(defn stack-value
  [value-text]
  {:text     (str value-text)
   :fontSize 7
   :color    (theme/color [:pdf :stack :value])})

(defn data-row-tabular-pdf
  [{:keys [_headers
           column-font-style-row
           _heading-count _rows _table-row-alignment]}
   row idx
   odd-color
   even-color
   heading-color
   heading-info-color
   subheading-color
   subtotal-color total-color empty-line-color table-style data-cell-alignment text-color]
  (let [{:keys [row-data row-highlight row-type row-font-style]} row
        data-heading (first row-data)
        data-value (rest row-data)
        background-color (cond
                           (not (cu/blank-value? row-type))
                           (case row-type
                             "heading"
                             heading-color
                             "heading info"
                             heading-info-color
                             "subheading"
                             subheading-color
                             "subtotal"
                             subtotal-color
                             "total"
                             total-color
                             "empty line"
                             empty-line-color)
                           (not (cu/blank-value? row-highlight))
                           row-highlight
                           (= table-style :table-style/none)
                           even-color
                           :else
                           (if (odd? idx) odd-color even-color))
        default-cell-borders (case row-type
                               "subtotal" [false true false true]
                               "total" [false true false true]
                               [false false false false])
        heading-text-style (first column-font-style-row)
        value-text-style (second column-font-style-row)
        heading-text {:text      data-heading
                      :alignment "left"}
        value-text {:text      data-value
                    :alignment (or data-cell-alignment "right")}
        row-config {:fillColor background-color
                    :color     (or text-color
                                   (case row-type
                                     "heading"
                                     (theme/color [:lp-report :table :pdf :heading-color :fg])
                                     "heading info"
                                     (theme/color [:lp-report :table :pdf :heading-info-color :fg])
                                     "subheading"
                                     (theme/color [:lp-report :table :pdf :subheading-color :fg])
                                     "#000000"))
                    :border    default-cell-borders}
        font-config-heading {:bold    (or (= "bold" (cu/str-trim-lcase heading-text-style))
                                          (= "bold" (cu/str-trim-lcase row-font-style)))
                             :italics (or (= "italic" (cu/str-trim-lcase heading-text-style))
                                          (= "italic" (cu/str-trim-lcase row-font-style)))}
        font-config-value {:bold    (or (= "bold" (cu/str-trim-lcase value-text-style)) ;;TODO maybe remove some duplicate code
                                        (= "bold" (cu/str-trim-lcase row-font-style)))
                           :italics (or (= "italic" (cu/str-trim-lcase value-text-style))
                                        (= "italic" (cu/str-trim-lcase row-font-style)))}]
    [(merge heading-text row-config (when (or heading-text-style row-font-style) font-config-heading))
     (merge value-text row-config (when (or value-text-style row-font-style) font-config-value))]))

(defn data-row-stacked-pdf
  [{:keys [_headers
           _column-font-style-row
           _heading-count _rows _table-row-alignment]} row]
  (let [{:keys [row-data _row-highlight _row-type _row-font-style]} row
        data-heading (first row-data)
        data-value (rest row-data)]
    (vec [[(stack-label data-heading)
           (stack-value (first data-value))]])))

(defn block-table-pdf
  [{:keys [parsed-data odd-row-background-color even-row-background-color heading-color heading-info-color
           subheading-color subtotal-color total-color empty-line-color font-size table-widths data-cell-alignment
           row-heights text-color]
    :as   _params}]
  (let [{:keys [table-row-alignment
                heading-count rows table-style pdf-column-width]}
        parsed-data
        last-heading-idx (atom 0)
        full-width (vec (repeat 2 "*"))
        lifeline? (= (theme/get-theme) :theme.lp-portal/lifeline)
        table-layout (cond
                       (= table-row-alignment "stacked")
                       :noBorders

                       lifeline?
                       {:paddingTop    (fn [_i _node] 0.5)
                        :paddingBottom (fn [_i _node] 0.5)}

                       :else
                       {})
        table-config {:layout   table-layout
                      :color    ()
                      :fontSize (cond (not (cu/blank-value? font-size))
                                      font-size
                                      (= (theme/get-theme) :theme.lp-portal/capman)
                                      9
                                      :else
                                      6)
                      :margin   [0 0 0 0]
                      :table    {:widths     (cond 
                                               table-widths 
                                               table-widths
                                               (or (empty? pdf-column-width) (some #(= nil %) pdf-column-width))
                                               full-width
                                               :else
                                               pdf-column-width)
                                 :heights    (cond
                                               row-heights
                                               row-heights
                                               lifeline?
                                               2
                                               :else
                                               nil)
                                 :headerRows heading-count
                                 :body       (into []
                                                   (concat
                                                    (->> rows
                                                         (map-indexed
                                                          (fn [row-index row]
                                                            (let [row-type (:row-type row)
                                                                  row-idx (if (some #(= row-type %)
                                                                                    ["subheading" "subtotal"
                                                                                     "empty line" "total"])
                                                                            (do (reset! last-heading-idx row-index)
                                                                                0)
                                                                            (- row-index @last-heading-idx))]
                                                              (case table-row-alignment
                                                                "tabular"
                                                                (vec (data-row-tabular-pdf parsed-data
                                                                                           row
                                                                                           row-idx
                                                                                           odd-row-background-color
                                                                                           even-row-background-color 
                                                                                           heading-color
                                                                                           heading-info-color
                                                                                           subheading-color
                                                                                           subtotal-color
                                                                                           total-color
                                                                                           empty-line-color
                                                                                           table-style
                                                                                           data-cell-alignment
                                                                                           text-color))
                                                                "stacked"
                                                                (data-row-stacked-pdf parsed-data row))))))))}}]
    table-config))

(defn table
  ([data] (table data {}))
  ([{:keys [_rich-content _rich-content-path _figures _font-size] :as data} props]
   (let [removed-since-empty? (->> data
                                   :figures
                                   :rows
                                   (filter (fn [{:keys [row-data]}]
                                             (seq (remove nil? row-data))))
                                   (count)
                                   (= 0))]
     (when-not removed-since-empty?
       (card/card
        ""
        (block-table-pdf {:parsed-data              (:figures data)
                          :odd-row-background-color (theme/color [:lp-report :table :pdf :odd-row :bg])
                          :even-row-background-color (or (:even-row-background-color props)
                                                         (theme/color [:lp-report :table :pdf :even-row :bg]))
                          :heading-color            (or (:custom-heading-color props)
                                                        (theme/color [:lp-report :table :pdf :heading-color :bg]))
                          :heading-info-color       (theme/color [:lp-report :table :pdf
                                                                  :heading-info-color :bg])
                          :subheading-color         (theme/color [:lp-report :table :pdf
                                                                  :subheading-color :bg])
                          :subtotal-color           (theme/color [:lp-report :table :pdf
                                                                  :subtotal-color :bg])
                          :total-color              (theme/color [:lp-report :table :pdf
                                                                  :total-color :bg])
                          :empty-line-color         (theme/color [:lp-report :table :pdf
                                                                  :empty-line-color :bg])
                          :font-size                (:font-size props)
                          :table-widths             (:table-widths props)
                          :data-cell-alignment      (:data-cell-alignment props)
                          :row-heights              (:row-heights props)
                          :text-color               (:text-color props)}))))))
